import {
  Button,
  Dialog,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { forwardRef } from "react";
import CustomDataGrid from "../../../../CustomComponents/CustomDataGrid";


const Transition = forwardRef((props, ref) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => {
  const appbarHeight = 70;
  return {
    root: { top: `${appbarHeight}px !important`, color: "blue" },
  };
});

const BusinessIncomeAssesRefDialog = ({ businessRefOpen, setBusinessRefOpen, referenceList}) => {
  const classes = useStyles();


  const referenceGridColumns = [
    {
      field: "sno",
      headerName: "S.NO",
      headerAlign: "center",
      align: "center",
      flex: 100,
      type: "string",
      editable: false,
    },
    {
      field: "referenceId",
      headerName: "Reference ID",
      headerAlign: "center",
      align: "center",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "businessAssessmentId",
      headerName: "Business Assessment ID",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "internalApplicationId",
      headerName: "Internal Application ID",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "isSupplier",
      headerName: "Is Supplier",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "name",
      headerName: "Name",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "contactNumber",
      headerName: "Contact Number",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "address",
      headerName: "Address",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "durationWithBusinessYears",
      headerName: "Duration With Business (Years)",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "durationWithBusinessMonths",
      headerName: "Duration With Business (Months)",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "businessDurationYears",
      headerName: "Business Duration (Years)",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "businessDurationMonths",
      headerName: "Business Duration (Months)",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "buyingItemSupplier",
      headerName: "Buying Item Supplier",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "sellingItemCustomer",
      headerName: "Selling Item Customer",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "isCustomerPaysRegularlySupplier",
      headerName: "Is Customer Pays Regularly Supplier",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "majorProblem",
      headerName: "Major Problem",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "isCreditExtended",
      headerName: "Is Credit Extended",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "amountPendingDays",
      headerName: "Amount Pending Days",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
    {
      field: "colorCodeId",
      headerName: "Color Code ID",
      headerAlign: "center",
      align: "right",
      flex: 200,
      type: "string",
      editable: false,
    },
  ];

  return (
    <>
      <Dialog
        fullScreen
        open={businessRefOpen}
        TransitionComponent={Transition}
        className={classes.root}
      >
        <Toolbar>
          <Typography
            sx={{
              ml: 2,
              flex: 1,
            }}
          >
            <h4>References</h4>
          </Typography>
            <Button variant="contained" 
              onClick={() => setBusinessRefOpen(false)}
            >
              Close
            </Button>
        </Toolbar>
        <Box
          sx={{
            marginTop: "8px",
            marginBottom: "8px",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              marginTop: "8px",
              marginBottom: "8px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CustomDataGrid
              noDataMessage="No Data"
              rows={(referenceList !== undefined && referenceList !== null) ?
                  referenceList.map((item, index) => ({
                  id: index + 1,
                  ...item,
                })) : []}
              columns={referenceGridColumns}
              getRowId={(row) => row.referenceId}
              pageSize={20}
              pageSizeOptions={[20]}
              gridLazyLoad={() => {}}
              gridHeight={490}
              gridWidth={window.innerWidth - 40}
            />
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
export default BusinessIncomeAssesRefDialog;
